// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"PageSidebar-sidebarContainer-aQa5n","sidebar":"PageSidebar-sidebar-KUJeR"};